import React from 'react';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';
import query, {
    CollectionLikersLoaderQuery,
    CollectionLikersLoaderQueryVariables,
} from './collection-likers-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
}

class CollectionLikersDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { id, open, onClose } = this.props;
        return (
            <Modal title={<FormattedMessage id='LIKE' />} open={open} onClose={onClose}>
                <Query<CollectionLikersLoaderQuery, CollectionLikersLoaderQueryVariables>
                    query={query}
                    variables={{ collectionId: id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.collection && data.collection.likers ? (
                                    <LikersList {...data.collection} />
                                ) : null}
                                {data &&
                                data.collection &&
                                data.collection.likers &&
                                data.collection.likers.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.collection &&
                                                data.collection.likers &&
                                                data.collection.likers.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as CollectionLikersLoaderQuery,
                                                    { fetchMoreResult = {} as CollectionLikersLoaderQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        post: {
                                                            ...(previousResult && previousResult.collection),
                                                            ...(fetchMoreResult && previousResult.collection),
                                                            likers: mapAfter(
                                                                previousResult.collection &&
                                                                    previousResult.collection.likers,
                                                                fetchMoreResult.collection &&
                                                                    fetchMoreResult.collection.likers
                                                            ),
                                                        },
                                                    } as CollectionLikersLoaderQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default Styled({})(CollectionLikersDialog);
